export function formSignature(data: FormData) {
	return JSON.stringify(
		Array.from(data, ([name, value]) => [
			name,
			value instanceof File
				? value.name
					? [value.name, value.size, value.type, value.lastModified]
					: null
				: value
		]).filter(([, value]) => value !== null)
	)
}
